import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const KitchenAccountAdd = () => {
  const { t } = useTranslation();
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const [errMessage, setErrMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [kitchenCodeSet, setKitchenCodeSet] = useState(new Set());
  const [inputValue, setInputValue] = useState("");
  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }
  // Fetch account code options
  useEffect(() => {
    const fetchCodes = async () => {
      try {
        // Fetch all account codes and already added ones
        const [allkitchen, KitchenAcc] = await Promise.all([
          http.get(`${BaseUrl}admin/account`),
          http.get(`${BaseUrl}admin/kitchenaccountlist`),
        ]);
        const allCodes = allkitchen.data.data || [];
        const kitchenCodes = KitchenAcc.data.data || [];
        // Build a Set of kitchen account codes
        const KitchenSet = new Set(
          kitchenCodes.map((item) => item.accountCode?.toLowerCase()),
        );
        setKitchenCodeSet(KitchenSet);
        // Filter only those not already added
        const availableCodes = allCodes.filter((item) => {
          return !KitchenSet.has(item.accountCode?.toLowerCase());
        });
        setAccountCodeOptions(availableCodes);
      } catch (err) {
        console.log(err);
      }
    };
    fetchCodes();
  }, []);
  // Redirect on cancel
  const handleCancel = (e) => {
    e.preventDefault();
    window.location.href = "/kitchenaccount";
  };
  // Form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setInputValue(""); // clear invalid typed value
    if (selectedCodes.length === 0) {
      setErrMessage(t("please_select_at_least_one_code_txt"));
      return;
    }
    const payload = {
      selectedAccountCodes: selectedCodes,
    };
    http
      .post(`${BaseUrl}admin/addkitchenaccount`, payload)
      .then((res) => {
        if (res.data.success) {
          setAlertPopup(true);
          setAlertMessage(t("account_codes_added_successfully_txt"));
          setTimeout(() => {
            window.location.href = "/kitchenaccount";
          }, 1500);
        } else {
          setErrorPopup(true);
          setErrorMessage(t("failed_to_add_account_codes_txt"));
        }
      })
      .catch((err) => {
        setErrorPopup(true);
        setErrorMessage(t("error_submitting_data_txt"));
        console.log(err);
      });
  };

  const customNoOptionsMessage = () => {
    const input = inputValue.trim().toLowerCase();
    if (kitchenCodeSet.has(input)) {
      return null; // Do not show any message if it's a kitchen code
    }
    if (input.length > 0) {
      return t("no_options_txt");
    }
    return null;
  };

  return (
    <>
      {errorPopup && <ShowAlert title={t("alert_txt")} message={errorMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title vi">{t("add_account_code_txt")}</h1>
              <div className="right-table-outer-wrap">
                <form
                  method="post"
                  className="addform form-container-xs"
                  onSubmit={handleSubmit}
                >
                  <div className="input-field col-1">
                    <label>{t("account_code_txt")}</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      noOptionsMessage={customNoOptionsMessage}
                      value={accountCodeOptions
                        .filter((opt) =>
                          selectedCodes.includes(opt.accountCode),
                        )
                        .map((opt) => ({
                          value: opt.accountCode,
                          label: `${opt.accountCode}`,
                        }))}
                      onChange={(selectedOptions) => {
                        const codes = selectedOptions.map((item) => item.value);
                        // No need to re-check kitchen here, handled in input validation
                        setSelectedCodes(codes);
                        setInputValue("");
                        if (codes.length > 0) setErrMessage("");
                      }}
                      onInputChange={(value, { action }) => {
                        // Handle only 'input-change' and 'input-blur'
                        if (action === "input-change") {
                          setInputValue(value);
                          const pastedCode = value.trim().toLowerCase();
                          if (kitchenCodeSet.has(pastedCode)) {
                            setErrMessage(
                              t("account_code_already_added_txt", {
                                accountCode: value,
                              })
                            );
                            setTimeout(() => {
                              setErrMessage("");
                              setInputValue(""); // Clear the pasted input
                            }, 1000);
                          }
                        }
                      }}
                      onBlur={() => {
                        setInputValue("");
                      }}
                      inputValue={inputValue}
                      options={accountCodeOptions.map((opt) => ({
                        value: opt.accountCode,
                        label: `${opt.accountCode}`,
                      }))}
                      className="form-control"
                      placeholder={t("select_acc_code_txt")}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: "relative",
                          zIndex: 2,
                        }),
                      }}
                    />
                    {errMessage && (
                      <div className="error-msg">{errMessage}</div>
                    )}
                  </div>
                  <button title={t("submit_txt")} type="submit" onMouseDown={(e) => e.preventDefault()}>
                    {t("submit_txt")}
                  </button>
                  &nbsp;&nbsp;
                  <button title={t("cancel_txt")} onClick={handleCancel}>{t("cancel_txt")}</button>
                </form>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default KitchenAccountAdd;
